module.exports = __webpack_public_path__ + "static/media/COS_PROCTER_AND_GAMBLE.931d7098.png";